import { reactive, ref, watch } from 'vue';
const useEditForm = props => {
  const {
    saveApi,
    queryApi,
    queryParams,
    afterQuery,
    beforeSave,
    afterSave,
    items: itemsProp,
    rules: rulesProp
  } = props;
  const formConfig = reactive({
    save: saveApi,
    query: queryApi,
    queryParams,
    // 查询附带参数, (id)=> {}||{}
    afterQuery,
    // ({ params, data }) => data, // 查询后的数据处理函数
    beforeSave,
    // ({data}) => data||false // 编辑前,返回false,取消保存
    afterSave,
    // ({data, result}) => result, 保存后// 返回false取消刷新
    items: itemsProp || [],
    rules: rulesProp || {}
  });
  watch(() => props, val => {
    const {
      saveApi,
      queryApi,
      queryParams,
      afterQuery,
      beforeSave,
      afterSave,
      items: itemsProp,
      rules: rulesProp,
      data: dataProp
    } = val || {};
    Object.assign(formConfig, {
      save: saveApi,
      query: queryApi,
      queryParams,
      afterQuery,
      beforeSave,
      afterSave,
      items: itemsProp || [],
      rules: rulesProp || {},
      data: dataProp || {}
    });
  }, {
    immediate: true,
    deep: true
  });
  const items = ref([]);
  watch(() => props.items, val => {
    items.value = val;
  }, {
    immediate: true,
    deep: true
  });
  const rules = reactive({
    ...formConfig.rules
  });
  const {
    loading: queryLoading,
    error: queryError,
    runAsync: queryDetailAsync
  } = fetchApi({
    getName() {
      return formConfig.query;
    }
  });
  const {
    loading: saveLoading,
    error: saveError,
    runAsync: saveAsync
  } = fetchApi({
    getName() {
      return formConfig.save;
    }
  });

  // 获取数据详情
  const getDetail = async id => {
    queryError.value = '';
    const {
      query,
      queryParams,
      afterQuery
    } = formConfig;
    if (!query || queryLoading.value) return Promise.resolve(false);
    const postParams = {
      id
    };
    if (queryParams && typeof queryParams === 'function') {
      const tmp = await queryParams({
        id
      });
      Object.assign(postParams, tmp);
    } else if (queryParams && typeof queryParams === 'object') {
      Object.assign(postParams, queryParams);
    }
    const {
      error,
      ...content
    } = await queryDetailAsync(postParams);
    if (error) {
      queryError.value = error;
      return Promise.resolve(false);
    }
    let resultData = content;
    if (typeof afterQuery === 'function') {
      resultData = await afterQuery({
        params: postParams,
        data: content
      });
    }
    Object.assign(props.data || {}, resultData);
    return Promise.resolve(resultData);
  };
  const saveForm = async () => {
    saveError.value = '';
    const {
      save: saveApi,
      beforeSave,
      afterSave
    } = formConfig;
    if (!saveApi || saveLoading.value) return Promise.resolve(false);
    let postData = {
      ...(props.props || {})
    };
    if (typeof beforeSave === 'function') {
      const tmp = await beforeSave(postData);
      if (!tmp) return Promise.resolve(false);
      postData = tmp;
    }
    const {
      error,
      ...res
    } = await saveAsync(postData);
    if (error) {
      saveError.value = error;
      return Promise.resolve(false);
    }
    if (typeof afterSave === 'function') {
      const ret = await afterSave({
        data: postData,
        result: res
      });
      return Promise.resolve(ret);
    }
    return Promise.resolve(res);
  };
  const updateFormConfig = config => {
    Object.assign(formConfig, config);
  };
  return {
    queryError,
    queryLoading,
    saveError,
    saveLoading,
    items,
    rules,
    data: props.data || {},
    getDetail,
    saveForm,
    formConfig,
    updateFormConfig
  };
};
export { useEditForm };